export default "__VITE_ASSET__Cm39H0US__"